import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/header_lg.jpg'
import _imports_1 from '../assets/images/como1.png'
import _imports_2 from '../assets/images/como2.png'
import _imports_3 from '../assets/images/como3.png'
import _imports_4 from '../assets/images/como4.png'
import _imports_5 from '../assets/images/chica.png'
import _imports_6 from '../assets/images/chico.png'


const _hoisted_1 = {
  id: "home",
  class: "d-flex align-items-center"
}
const _hoisted_2 = { class: "container header" }
const _hoisted_3 = { class: "row md:hidden lg:hidden xl:hidden" }
const _hoisted_4 = { class: "col-sm-12 col-md-12 mr-0 card-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "promo_lg_mobile pb-0 pt-3 text-center font-weight-bold-900 text-red" }, " Nuestro servicio es 100% gratuito. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "promo_lg_title_mobile text-center header-title-mobile pt-0 font-weight-bold-900 text-blue" }, " Responde 3 preguntas, y déjanos sorprenderte ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "subtitle promo_lg_txt_mobile pt-0 text-center text-blue max700" }, " Haz clic en el botón, responde las preguntas, y te mostraremos los mejores cursos, diplomados, carreras y talleres disponibles para ti ", -1)
const _hoisted_8 = { class: "col-md-5 mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-lg-4 offset-lg-1 ml-0 card-container mt-4 mb-3 text-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "male",
    src: _imports_0,
    class: "img-header-mobile"
  })
], -1)
const _hoisted_10 = { class: "row ml-5 mr-5 xs:hidden home-web" }
const _hoisted_11 = { class: "col-sm-12 col-lg-6 mr-0 card-container" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "promo_lg pb-0 pt-3 font-weight-bold-900 text-red" }, " Nuestro servicio es 100% gratuito. ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "promo_lg_title header-title pt-0 font-weight-bold-900 text-blue" }, " Responde 3 preguntas, y déjanos sorprenderte ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "subtitle pt-0 text-blue max700" }, " Haz clic en el botón, responde las preguntas, y te mostraremos los mejores cursos, diplomados, carreras y talleres disponibles para ti ", -1)
const _hoisted_15 = { class: "col-md-5 ml-4 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-lg-6 offset-lg-1 ml-0 card-container mt-4 pt-4 text-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "male",
    src: _imports_0,
    class: "img-header"
  })
], -1)
const _hoisted_17 = {
  id: "work",
  class: "section-padding d-flex align-items-center h100 pt-0 mb-0 pb-0"
}
const _hoisted_18 = { class: "container" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mb-0 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "work mb-0 -900 work-title text-red" }, " Cómo funciona ")
  ])
], -1)
const _hoisted_20 = { class: "row ml-5 mr-5" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = { class: "row ml-3" }
const _hoisted_23 = { class: "col-lg-9 sm-10 pl-0 pr-0" }
const _hoisted_24 = { class: "row mt-8" }
const _hoisted_25 = { class: "col-lg-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-sm-10 col-xs-10 pl-0 pr-0 text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Cómo funciona"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 pl-0 pr-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "Cómo funciona"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 pl-0 pr-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "Cómo funciona"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 pl-0 pr-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "Cómo funciona"
    })
  ])
], -1)
const _hoisted_27 = { class: "row justify-content-center" }
const _hoisted_28 = { class: "col-lg-4 text-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 pl-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "Cómo funciona"
  })
], -1)
const _hoisted_30 = {
  id: "benefits",
  class: "section-padding d-flex align-items-center h50 bg-work pt-0 mb-0 pb-0"
}
const _hoisted_31 = { class: "container" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mt-0 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "work mt-4 mb-0 work-title text-white" }, " Beneficios ")
  ])
], -1)
const _hoisted_33 = { class: "row m-benefits" }
const _hoisted_34 = { class: "col-lg-12" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 chico-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "Cómo funciona"
  })
], -1)
const _hoisted_37 = { class: "col-lg-9 col-sm-12 pl-7 pr-0" }
const _hoisted_38 = { class: "row mt-6" }
const _hoisted_39 = { class: "col-lg-12" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-lg-4 pl-0 pr-3 block-shadow cards-bene\"><ul class=\"beneficios_icon\"><li class=\"icono_bene\"><i class=\"fas fa-globe-americas mb-4 tex_bene\"></i></li><li class=\"tex_bene\"><h4 class=\"font-weight-bold\">Desde cualquier lugar</h4><p class=\"ml-0\">El proceso es 100% por internet</p></li></ul></div><div class=\"col-lg-4 pl-0 pr-3 block-shadow cards-bene\"><ul class=\"beneficios_icon\"><li class=\"icono_bene\"><i class=\"far fa-handshake mb-4 tex_bene\" style=\"padding-right:69px;\"></i></li><li class=\"tex_bene\"><h4 class=\"font-weight-bold\">Somos tu aliado</h4><p class=\"ml-0\">Te acercamos con las mejores ofertas para ti</p></li></ul></div><div class=\"col-lg-4 pl-0 pr-3 block-shadow cards-bene\"><ul class=\"beneficios_icon\"><li class=\"icono_bene\"><i class=\"fas fa-tasks mb-4 tex_bene\"></i></li><li class=\"tex_bene\"><h4 class=\"font-weight-bold\">Proceso personalizado</h4><p class=\"ml-0\">Aplica una vez y obtén muchas opciones</p></li></ul></div></div><div class=\"row\"><div class=\"col-lg-4 pl-0 pr-3 block-shadow cards-bene\"><ul class=\"beneficios_icon\"><li class=\"icono_bene\"><i class=\"fas fa-shield-alt mb-4 tex_bene\"></i></li><li class=\"tex_bene\"><h4 class=\"font-weight-bold\">Seguridad Total</h4><p class=\"ml-0\">Tus datos están seguros</p></li></ul></div><div class=\"col-lg-4 pl-0 pr-3 block-shadow cards-bene\"><ul class=\"beneficios_icon\"><li class=\"icono_bene\"><i class=\"fas fa-medal mb-4 tex_bene\"></i></li><li class=\"tex_bene\"><h4 class=\"font-weight-bold\">100% confiable</h4><p class=\"ml-0\">Obten respuesta en 90 segundos</p></li></ul></div><div class=\"col-lg-3 pl-0 pr-3 block-shadow cards-bene\"><ul class=\"beneficios_icon\"><li class=\"icono_bene icono_bene_like\"><i class=\"far fa-thumbs-up mb-4 tex_bene\"></i></li><li class=\"tex_bene\"><h4 class=\"font-weight-bold\">Servicio de calidad</h4><p class=\"ml-0\">Miles de usuarios felices</p></li></ul></div><div class=\"col-lg-3 pl-0 pr-0 block-shadow\"></div></div>", 2)
const _hoisted_42 = { class: "row mb-6 mt-4 btn-benefits justify-content-center" }
const _hoisted_43 = { class: "col-lg-5 col-md-2 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                onClick: _ctx.go,
                label: "Vamos",
                iconPos: "right",
                icon: "fas fa-angle-double-right",
                class: "btn-go p-button-raised p-button-rounded font-weight-bold"
              }, null, 8, ["onClick"])
            ])
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Button, {
                onClick: _ctx.go,
                label: "Vamos",
                iconPos: "right",
                icon: "fas fa-angle-double-right",
                class: "btn-go p-button-raised p-button-rounded font-weight-bold"
              }, null, 8, ["onClick"])
            ])
          ]),
          _hoisted_16
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_Button, {
                          onClick: _ctx.go,
                          iconPos: "right",
                          label: "Ponme a prueba",
                          icon: "fas fa-angle-double-right",
                          class: "p-button-raised p-button-rounded font-weight-bold text-white text-900"
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_29
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_Button, {
                          onClick: _ctx.go,
                          iconPos: "right",
                          label: "Ir al cuestionario",
                          icon: "fas fa-angle-double-right",
                          class: "p-button-raised p-button-rounded font-weight-bold text-white text-900"
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}